import React, {useState} from "react";
import {CheckboxField, CheckboxLabel, Input} from "./widgets/Styled";
import {ErrorHelperText} from "../Textfield/widgets/Styled";
import {FieldInputProps} from "react-final-form";

/**
- Use an avatar for attributing actions or content to specific users.
- The user's name should always be present when using Avatar – either printed beside the avatar or in a tooltip.
**/

interface CheckboxInterface {
    id: string;
    isChecked?: boolean;
    isDisabled?: boolean;
    label?: string;
    isError?: boolean;
    value?: number;
    onChange?(): void;
    inputRFF?: FieldInputProps<boolean, HTMLElement>;
    error?: string;
    isFocused?: boolean;
    CheckBoxStyle?: {
        mobile: {top: string};
        laptop: {top: string};
    };
    errorDivStyle?: {
        mobile: {
            top: string;
            left: string;
        };
        laptop: {
            top: string;
            left: string;
        };
    };
}

const CheckBox: React.FC<CheckboxInterface> = ({
    isChecked = false,
    isDisabled = false,
    label,
    id,
    isError = false,
    CheckBoxStyle,
    inputRFF,
    error,
    isFocused,
    onChange,
    errorDivStyle = {
        mobile: {top: "50px", left: "-5px"},
        laptop: {top: "30px", left: "-5px"},
    },
    ...rest
}: CheckboxInterface) => {
    const [checked, setChecked] = useState(isChecked);

    return (
        <CheckboxField isError={isError}>
            <Input
                type="checkbox"
                {...(!inputRFF
                    ? {
                          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                              if (onChange) {
                                  onChange();
                              }
                              setChecked(e.target.checked);
                          },
                          checked: checked,
                      }
                    : {})}
                id={id}
                disabled={isDisabled ? "disabled" : ""}
                aria-labelledby={id}
                aria-checked="false"
                isError={isError}
                CheckBoxStyle={CheckBoxStyle}
                {...(inputRFF ? {...inputRFF} : {})}
                {...rest}
            />
            {label && (
                <CheckboxLabel
                    htmlFor={id}
                    checked={!inputRFF ? checked : inputRFF.checked}
                    disabled={isDisabled}
                    isError={isError}
                    CheckBoxStyle={CheckBoxStyle}
                >
                    {label}
                </CheckboxLabel>
            )}

            {isError && isFocused && (
                <ErrorHelperText alignLeft ErrorDivStyle={errorDivStyle}>
                    {error}
                </ErrorHelperText>
            )}
        </CheckboxField>
    );
};

export default CheckBox;
